<!-- // welcome section \\ -->
<section class="welcome-section">
  <div class="comman-width">
    <div class="welcome-center">
      <h2>Save up to 80% on your prescriptions</h2>

      <!-- <app-search></app-search> -->
      <!-- search start -->
      <div class="search-fields">
        <app-search></app-search>
      </div>
      <!-- search end -->

      <div class="search">
        <ul>
          <li>
            <div class="image">
              <img src="../assets/images/best-price.svg" />
            </div>
            <span>Search for the best price</span>
          </li>
          <li>
            <div class="image">
              <img src="../assets/images/id-card.svg" />
            </div>
            <span>Get your card<br />&nbsp;</span>
          </li>
          <li>
            <div class="image">
              <img src="../assets/images/show-id.svg" />
            </div>
            <span>Show pharmacist at time of purchase</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
<!-- \\ welcome section // -->

<div class="clearfix"></div>

<!-- // welcome section \\ -->
<section class="accept-section">
  <h2>Accepted at approximately 35,000 Pharmacies nationwide</h2>

  <ul class="comman-width">
    <li *ngFor="let Item of acceptLogoArray">
      <img src="{{ Item.img }}" alt="{{ Item.alt }}" />
    </li>
  </ul>

  <!-- <a
    href="javascript:;"
    href="javascript:;"
    data-toggle="modal"
    data-target="#myModal"
    class="card btn-hover-effect"
    ><div class="insider"></div>
    Get Your Card Now</a -->
</section>
<!-- \\ welcome section // -->

<!-- Static card sec -->

<!-- <div class="cardbox_p">
  <div class="card_box">
    <div class="card_box_header">
      Pharmacy Discount Card
    </div>
    <div class="card_box_body">
      <div class="logo_phone">
        <div class="img_logo">
          <img src="../assets/images/logo.png" alt="" />
        </div>
        <div class="member_support">
          <span>Member Support</span>
          <span>
          </span>
        </div>
      </div>
      <div class="bin_pcn_member_id">
        <div>
          <span>BIN</span>
          <div>023518</div>
        </div>
        <div>
          <span>PCN</span>
          <div>ARX</div>
        </div>
        <div>
          <span>Group # (Access Code)</span>
          <div>HELP777</div>
        </div>

        <div>
          <span>MEMBER ID</span>
          <div>100-4542</div>
        </div>
      </div>
      <p><strong>This is not insurance</strong>. This card is free.</p>
    </div>
  </div>
  <div class="card_box">

    <div class="card_box_body">
      <table>

        <tr>
          <td>
            <p style="padding:0;margin:0;border-right:1px solid #eee;padding-right: 8px">
              <strong>Member Instructions</strong><br>
              1. Present card to your pharmacist<br>
              2. Ask for discount on each prescription
              and save!<br>
              3. Use over and over! It does not expire
            </p>
            <p style="padding:0;margin:0;border-right:1px solid #eee;padding-right: 8px">
              Visit <a href="https://{{brandName}}.com/" style="color:#27524B;text-decoration:none;">{{brandName}}.com</a>,
              download the {{brandName}} app,
              or call <a href="tel:8009844031"
                style="color:#27524B;text-decoration:none;font-weight:bold">800-984-4031</a> for more
              information, to report any concerns and to
              find participating pharmacies near you! The
              {{brandName}} Program, prices, list of covered
              drugs, and participating pharmacies are
              subject to change.
            </p>


          </td>
          <td style="padding-left: 8px;">
            <strong>Pharmacist Instructions</strong><br>
            This card is pre-activated and
            gives member discounts
            through the BIN, PCN, Group on
            the front. If you need assistance
            call <a href="tel:8778007820" style="color:#27524B;text-decoration:none;">(877)
              800-7820</a>.<br><br>
            <strong>Accepted at approximately 35,000 Pharmacies nationwide</strong>
            <p style="padding:0;margin:0;margin-top:5px">
              <img src="../../assets/images/pharmacylogos.png" />
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            By using this card, you have agreed to the terms and conditions found at
            <a href="https://{{brandName}}.com/terms-and-conditions"
              style="color:#27524B;text-decoration:none;">{{brandName}}.com/terms</a>. The {{brandName}} Program is
            administered by {{brandName}}, One
            Marina Park Drive, Suite 1410, Boston MA
            <br /><br />
            The CVS, KROGER, WALMART and WALGREENS logos are the trademarks and/
            or registered trademarks of CVS, KROGER, WALMART and WALGREENS (or one
            of their respective affiliates), respectively.
          </td>
        </tr>
      </table>
    </div>
  </div>
</div> -->
<!-- discount card  -->
<div class="home_cards">
  <img src="../assets/images/front_card.png" />
  <img src="../assets/images/back_card.png" />
</div>

<!-- // work section \\ -->
<section class="work-section">
  <h2>How does it work?</h2>
  <p>On behalf of consumers nationwide, {{brandName}} has negotiated a discount rate with a national network of drugstores and retail outlets. Approximately 35,000 stores have partnered with {{ brandName }} to offer prescription assistance to the uninsured and under-insured.</p>
</section>
<!-- \\ work section // -->

<!-- // carosuel section \\ -->



<!-- <section class="carosuel-section">
  <div class="comman-width">
    <h2>Customer's Speak</h2>
    <div class="row">
      <div class="col-lg-12">
        <ngx-slick-carousel
          class="carousel"
          #slickModal="slick-carousel"
          [config]="slideConfig"
        >
          <div ngxSlickItem *ngFor="let slide of slides" class="slide">
            <div class="shadow">
              <img src="{{ slide.img }}" alt="pharmacist" />
              <h3>{{ slide.heading }}</h3>
              <p>{{ slide.text }}</p>
            </div>
          </div>
        </ngx-slick-carousel>
      </div>
    </div>
  </div>
</section> -->


<!-- \\ carosuel section // -->

<div class="clearfix"></div>

<!-- // download section \\ -->
<!-- <section class="download-section">
  <div class="comman-width">
    <div class="row">
      <div class="col-lg-12">
        <span>Download our FREE top rated App</span>
        <h2>Get {{ secondBrandName }} on the Go</h2>

        <img class="gap" src="assets/images/app-store.png" />

        <img src="assets/images/play-store.png" />

        <span class="get">or get the download link</span>

        <form class="{{ sendmessageClass }}">
          <input
            type="text"
            name="phone-number"
            class="form-control"
            [(ngModel)]="sendno"
            placeholder="Enter your mobile number"
            (keypress)="removemsgerr($event)"
            (focus)="removemsgerr($event)"
          />
          <button
            (click)="sendmsg(sendno)"
            type="submit"
            class="btn btn-hover-effect"
          >
            <div class="insider"></div>
            Get Download Link
          </button>
          <span>{{ sendmessageStatus }}</span>
        </form>
      </div>
    </div>
  </div>
</section> -->
<!-- \\ download section // -->
<!-- <app-getcard></app-getcard> -->
